import { SVGProps } from 'react';

const SvgVerifiedShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 23 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.318 2 1.2 6.237v5.72C1.064 15.348 2.894 23.103 11.318 27c3.44-1.695 10.115-7.075 10.115-15.042 0-7.84.166-4.958 0-5.72L11.318 2Z"
      stroke="#FE3B1F"
      strokeWidth={2}
    />
    <path
      d="m10.19 14.95-2.13-2.13L7 13.88l3.18 3.18 6-6L15.12 10l-4.93 4.95Z"
      fill="#fff"
    />
  </svg>
);

export default SvgVerifiedShield;
